var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      {
        staticClass: "bold tiny grey-text text-uppercase clickable",
        on: { click: _vm.toggleExpandBankStatements },
      },
      [
        _c("icon", {
          staticClass: "text-primary",
          attrs: { name: "university" },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "mx-1" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("application.bankStatements")) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("icon", {
          attrs: {
            name: _vm.expandedBankStatements ? "caret-up" : "caret-down",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.expandedBankStatements
      ? _c("div", { staticClass: "px-3" }, [
          _c(
            "p",
            { staticClass: "small text-gray w-100 mb-0 regular-line-height" },
            [
              _c("span", { staticClass: "bold" }, [
                _vm._v(_vm._s(_vm.$t("application.monthsRequested")) + ": "),
              ]),
              _vm._v("\n      " + _vm._s(_vm.monthsRequested) + "\n    "),
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "small text-gray w-100 mb-0 regular-line-height" },
            [
              _c("span", { staticClass: "bold" }, [
                _vm._v(_vm._s(_vm.$t("email.sentTo")) + ": "),
              ]),
              _vm._v(" " + _vm._s(_vm.emails) + "\n    "),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }